"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const styles = (_theme) => ({
    buttonRoot: {
        padding: 0,
        minWidth: 'unset',
    },
    iconRoot: {
        fontSize: 20,
    },
});
exports.styles = styles;
